import { ValueState } from "sap/ui/core/library";
import { WorkOrderStatus } from "../constants/WorkOrderStatuses";
import { ConfirmDialogData } from "../models/ConfirmDialogData";

export default function GetWorkOrderChangeStatusDialogData(
  newStatus: WorkOrderStatus
): ConfirmDialogData {
  switch (newStatus) {
    case "cancelled":
      return {
        title: "cancelledWorkOrder",
        message: "cancelledWorkOrderQuestion",
        dialogState: ValueState.Error,
      };
    case "closed":
      return {
        title: "closedWorkOrder",
        message: "closedWorkOrderQuestion",
        dialogState: ValueState.Warning,
      };
    case "rejected":
      return {
        title: "rejectedWorkOrder",
        message: "rejectedWorkOrderQuestion",
        dialogState: ValueState.Error,
      };
    case "finished":
      return {
        title: "finishedWorkOrder",
        message: "finishedWorkOrderQuestion",
        dialogState: ValueState.Success,
      };
    case "inProgress":
      return {
        title: "inProgressWorkOrder",
        message: "inProgressWorkOrderQuestion",
        dialogState: ValueState.Information,
      };
    case "notAccepted":
      return {
        title: "notAcceptedWorkOrder",
        message: "notAcceptedWorkOrderQuestion",
        dialogState: ValueState.Warning,
      };
    case "new":
      return {
        title: "newWorkOrderToTheContractor",
        message: "newWorkOrderQuestion",
        dialogState: ValueState.Information,
      };
    case "draft":
      return {
        title: "draftWorkOrder",
        message: "draftWorkOrderQuestion",
        dialogState: ValueState.Information,
      };
    default:
      return {
        title: "statusNotFound",
        message: "statusNotFoundMessage",
        dialogState: ValueState.Error,
      };
  }
}
